// Import react elements
import { NavLink } from "react-router-dom";

// Import app config
import { useAppConfig } from "global/hooks/useAppConfig";

// Import icons
import {
    DashboardIcon,
    OrdersIcon,
    PodDesignsIcon,
    AiGenerationIcon,
    ImagesIcon,
    StoresIcon,
    BalanceTransactionsIcon,
    AccountIcon,
    CustomProductsIcon,
    ManageMMMsIcon,
    PlansIcon
} from "global/strich_icons/StrichIcons"



const Sidebar = ({ toggleSidebar, sidebarOpen, setSidebarOpen, isMobile }) => {

    // Get the current environment configuration
    const appConfig = useAppConfig();


    // Set layout for pages and sub pages
    const sidebarLinks = [
        {
            label: "Dashboard",
            icon:
                <DashboardIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/dashboard",
        },
        {
            label: "Orders",
            icon:
                <OrdersIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/orders",
        },
        {
            label: "Balance",
            icon:
                <BalanceTransactionsIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/transactions",
        },
        {
            label: "Designs",
            icon:
                <PodDesignsIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/designs",
            end: true,
        },
        {
            label: "Templates",
            icon:
                <PodDesignsIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/designs/templates",
        },
        {
            label: "AI Studio",
            icon:
                <AiGenerationIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/ai-studio",
        },
        {
            label: "Images",
            icon:
                <ImagesIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/image-bucket",
        },
        {
            label: "Stores",
            icon:
                <StoresIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/stores",
        },
        {
            label: "Plans",
            icon:
                <PlansIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/plans",
        },
        {
            label: "Account",
            icon:
                <AccountIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/account",
        },
        {
            label: "Custom Products",
            icon:
                <CustomProductsIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/custom-products/manage-products",
            developmentOnly: true,
            sectionBreak: true,
        },
        {
            label: "Materials, Methods, Modes",
            icon:
                <ManageMMMsIcon
                    size={24}
                    className="global-icon global-icon--light sidebar__item-icon"
                />,
            to: "/custom-products/MMMs",
            developmentOnly: true,
        },

        // Add more sections here

    ];

    return (

        <aside className={`sidebar ${sidebarOpen ? "open" : "closed"} ${isMobile ? "is_mobile" : "is_desktop"}`}>

            <br />
            <br />

            {isMobile ?

                sidebarOpen ?

                    ""
                    :

                    <button className="sidebar__toggle-sidebar-btn" onClick={toggleSidebar}>{sidebarOpen ? "-" : <img src="/images/icon_menu.png" alt="menu" className="header_menu_icon" />}</button>

                :

                <button className="sidebar__toggle-sidebar-btn" onClick={toggleSidebar}>{sidebarOpen ? "❮" : "❯"}</button>

            }



            <div className="sidebar--logo">

                { /* <img src={sidebarOpen ? "/images/logo_wide.png" : "/images/logo_thin.png"} alt="Strichsuite" /> */}

                {isMobile ?

                    <img src="/images/logo_mobile.png" alt="Strichsuite" className="logo_mobile" />

                    :

                    sidebarOpen ?

                        <img src="/images/logo_wide.png" alt="Strichsuite" className={sidebarOpen ? "" : "logo"} />

                        :

                        <img src="/images/thestrich.png" alt="Strichsuite" style={{ height: "40px" }} />

                }



                {isMobile ?

                    sidebarOpen ?

                        <div>

                            <button
                                className="header-container-left__toggle-sidebar-btn"
                                tabIndex={0}
                                onClick={() => {
                                    setSidebarOpen(false);
                                }}
                            >
                                ❮
                            </button>

                        </div>

                        :

                        ""

                    :

                    ""

                }


            </div>



            <nav>

                <ul className="sidebar-nav">

                    {sidebarLinks.map((link) => {

                        // Hide development-only tools when this environment does not expose them
                        if (link.developmentOnly && !appConfig.showCustomProducts) return null;

                        return (

                            <li
                                key={link.to}
                                className={`${link.sectionBreak ? "sidebar-nav__item--section-break " : ""}${link.developmentOnly ? "sidebar-nav__item--development-tool" : ""}`}
                            >

                                <NavLink
                                    to={link.to}
                                    end={link.end}
                                    className={({ isActive }) =>
                                        `sidebar-dropdown__link${isActive ? " sidebar-dropdown__link--active" : ""}`
                                    }
                                >
                                    <div className="sidebar-nav-item__icon" title={link.label}>{link.icon}</div>
                                    <span className="sidebar-nav-item__title">{link.label}</span>
                                </NavLink>

                            </li>

                        );

                    })}

                </ul>


                <div className="sidebar-TandCs-container">

                    <NavLink to="/terms-and-conditions">
                        {sidebarOpen ? "Terms & Conditions" : "T&Cs"}
                    </NavLink>

                    <br/>

                    <NavLink to="/privacy-notice"> 
                        {sidebarOpen ? "Privacy Notice" : "Privacy"}
                    </NavLink>
                    
                </div>

            </nav>

        </aside>

    );

};

export default Sidebar;
